export default {
  stylePrefix: 'mdl-',

  title: '',

  content: '',

  backdrop: true,

  // Avoid rendering the default modal.
  custom: false,

  /**
   * Extend ModalView object (view/ModalView.js)
   * @example
   * extend: {
   *   template() {
   *     return '<div>...New modal template...</div>';
   *   },
   * },
   */
  extend: {}
};
